import React, { useState, useRef, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { mentorApiService, MentorData } from '../../../services/admin/mentorApi';
import {
  ActionButtons,
  Actions,
  BannerUpload,
  ButtonContent,
  ButtonLabel,
  ErrorText,
  Form,
  FormRow,
  FullWidthSection,
  HelperText,
  HiddenInput,
  ImagePreview,
  ImageUploadSection,
  InputBox,
  InputGroup,
  InputWrapper,
  IntroductionUpload,
  Label,
  MessageBox,
  PageContainer,
  PageTitle,
  PreviewImage,
  SaveDraftButton,
  SelectBox,
  SelectIcon,
  SelectInput,
  SubmitButton,
  SubmitButtonWrap,
  Tag,
  TagInput,
  TagRemoveButton,
  TagsContainer,
  TagText,
  TextInput,
  ThumbnailGroup,
  ThumbnailUpload,
  TitleSection,
  UploadIcon,
  UploadPlaceholder,
  UploadText,
} from './MentorRegisterStyles';
interface MentorFormData {
  name: string;
  email: string;
  department: string;
  tags: string[];
  categoryName: string;
  imageUrl: string;
  bannerUrl: string;
  introduction: string;
}

interface FormErrors {
  name?: string;
  email?: string;
  department?: string;
}

const MentorRegisterComponent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const mentorId = searchParams.get('id');
  const isEditMode = !!mentorId;

  const [formData, setFormData] = useState<MentorFormData>({
    name: '',
    email: '',
    department: '',
    tags: [],
    categoryName: '',
    imageUrl: '',
    bannerUrl: '',
    introduction: ''
  });

  const [errors, setErrors] = useState<FormErrors>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const [thumbnailPreview, setThumbnailPreview] = useState<string>('');
  const [bannerPreview, setBannerPreview] = useState<string>('');
  const [introductionImagePreview, setIntroductionImagePreview] = useState<string>('');

  const thumbnailInputRef = useRef<HTMLInputElement>(null);
  const bannerInputRef = useRef<HTMLInputElement>(null);
  const introductionImageInputRef = useRef<HTMLInputElement>(null);

  // ?섏젙 紐⑤뱶????硫섑넗 ?곗씠??遺덈윭?ㅺ린
  useEffect(() => {
    if (isEditMode && mentorId) {
      fetchMentorData(parseInt(mentorId));
    }
  }, [mentorId, isEditMode]);

  const fetchMentorData = async (id: number) => {
    try {
      /// console.log(`?뱻 硫섑넗 ?곗씠??濡쒕뵫 ?쒖옉 - ID: ${id}`);
      
      // 癒쇱? localStorage?먯꽌 ?곗씠???뺤씤
      const storedData = localStorage.getItem('editingMentor');
      if (storedData) {
        const mentor = JSON.parse(storedData);
        /// console.log('?벀 localStorage?먯꽌 硫섑넗 ?곗씠??濡쒕뱶:', mentor);
        
        // ID媛 ?쇱튂?섎뒗吏 ?뺤씤
        if (mentor.id === id) {
          // tags 泥섎━: 臾몄옄?댁씠硫?諛곗뿴濡?蹂?? 諛곗뿴?대㈃ 洹몃?濡??ъ슜
          let tagsArray: string[] = [];
          if (typeof mentor.tags === 'string') {
            // ?쇳몴濡?援щ텇??臾몄옄?댁쓣 諛곗뿴濡?蹂?섑븯怨?怨듬갚 ?쒓굅
            tagsArray = mentor.tags.split(',').map((tag: string) => tag.trim()).filter((tag: string) => tag.length > 0);
          } else if (Array.isArray(mentor.tags)) {
            tagsArray = mentor.tags;
          }
          
          // ???곗씠???ㅼ젙
          setFormData({
            name: mentor.name || '',
            email: mentor.email || '',
            department: mentor.department || '',
            tags: tagsArray,
            categoryName: mentor.category_name || mentor.categoryName || '',
            imageUrl: mentor.image_url || mentor.imageUrl || '',
            bannerUrl: mentor.banner_url || mentor.bannerUrl || '',
            introduction: mentor.introduction || ''
          });

          // ?대?吏 誘몃━蹂닿린 ?ㅼ젙
          if (mentor.image_url || mentor.imageUrl) {
            const imageUrl = mentor.image_url || mentor.imageUrl;
            setThumbnailPreview(imageUrl);
            /// console.log('?몃꽕???ㅼ젙:', imageUrl);
          }
          
          if (mentor.banner_url || mentor.bannerUrl) {
            const bannerUrl = mentor.banner_url || mentor.bannerUrl;
            setBannerPreview(bannerUrl);
            /// console.log('諛곕꼫 ?ㅼ젙:', bannerUrl);
          }
          
          if (mentor.introduction) {
            setIntroductionImagePreview(mentor.introduction);
            /// console.log('?뚭컻 ?대?吏 ?ㅼ젙:', mentor.introduction);
          }
          
          /// console.log('??localStorage?먯꽌 硫섑넗 ?곗씠??濡쒕뱶 ?꾨즺');
          
          // ?ъ슜 ??localStorage ?뺣━
          localStorage.removeItem('editingMentor');
          return;
        }
      }
      
      // localStorage???곗씠?곌? ?녾굅??ID媛 ?ㅻⅨ 寃쎌슦 API ?몄텧 ?쒕룄
      /// console.log('?뮶 localStorage???곗씠???놁쓬, API ?몄텧 ?쒕룄');
      const response = await fetch(`/api/admin/mentors/${id}`);
      
      /// console.log('API ?묐떟 ?곹깭:', response.status, response.ok);
      
      if (!response.ok) {
        // API ?ㅽ뙣?쒖뿉??硫섑넗 紐⑸줉 API濡??쒕룄
        /// console.log('?뱥 媛쒕퀎 議고쉶 ?ㅽ뙣, 紐⑸줉 API濡??쒕룄');
        const listResponse = await fetch(`/api/admin/mentors/list?size=100`);
        
        if (listResponse.ok) {
          const listData = await listResponse.json();
          const mentorFromList = listData.data?.content?.find((m: any) => m.id === id);
          
          if (mentorFromList) {
            /// console.log('??紐⑸줉 API?먯꽌 硫섑넗 李얠쓬:', mentorFromList);
            processMentorData(mentorFromList);
            return;
          }
        }
        
        throw new Error('멘토 정보를 불러오는데 실패했습니다.');
      }
      
      const result = await response.json();
      /// console.log('?뱤 諛쏆븘??硫섑넗 ?곗씠??', result);
      
      const mentor = result.data || result;
      processMentorData(mentor);
      
    } catch (error) {
      /// console.error('??硫섑넗 ?곗씠??濡쒕뱶 ?ㅻ쪟:', error);
      setMessage({ type: 'error', text: '멘토 정보를 불러오는데 실패했습니다.' });
    }
  };

  // 硫섑넗 ?곗씠??泥섎━ ?⑥닔
  const processMentorData = (mentor: any) => {
    /// console.log('?뱥 泥섎━??硫섑넗 ?곗씠??', mentor);
    
    // tags 泥섎━: 臾몄옄?댁씠硫?諛곗뿴濡?蹂?? 諛곗뿴?대㈃ 洹몃?濡??ъ슜
    let tagsArray: string[] = [];
    if (typeof mentor.tags === 'string') {
      // ?쇳몴濡?援щ텇??臾몄옄?댁쓣 諛곗뿴濡?蹂?섑븯怨?怨듬갚 ?쒓굅
      tagsArray = mentor.tags.split(',').map((tag: string) => tag.trim()).filter((tag: string) => tag.length > 0);
    } else if (Array.isArray(mentor.tags)) {
      tagsArray = mentor.tags;
    }
    
    // ???곗씠???ㅼ젙
    setFormData({
      name: mentor.name || '',
      email: mentor.email || '',
      department: mentor.department || '',
      tags: tagsArray,
      categoryName: mentor.category_name || mentor.categoryName || '',
      imageUrl: mentor.image_url || mentor.imageUrl || '',
      bannerUrl: mentor.banner_url || mentor.bannerUrl || '',
      introduction: mentor.introduction || ''
    });

    // ?대?吏 誘몃━蹂닿린 ?ㅼ젙
    if (mentor.image_url || mentor.imageUrl) {
      const imageUrl = mentor.image_url || mentor.imageUrl;
      setThumbnailPreview(imageUrl);
      /// console.log('?몃꽕???ㅼ젙:', imageUrl);
    }
    
    if (mentor.banner_url || mentor.bannerUrl) {
      const bannerUrl = mentor.banner_url || mentor.bannerUrl;
      setBannerPreview(bannerUrl);
      /// console.log('諛곕꼫 ?ㅼ젙:', bannerUrl);
    }
    
    if (mentor.introduction) {
      setIntroductionImagePreview(mentor.introduction);
      /// console.log('?뚭컻 ?대?吏 ?ㅼ젙:', mentor.introduction);
    }
    
    /// console.log('??硫섑넗 ?곗씠??濡쒕뱶 ?꾨즺');
  };

  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = '멘토 이름은 필수입니다';
    }

    if (!formData.email.trim()) {
      newErrors.email = '이메일은 필수입니다';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = '올바른 이메일 형식을 입력해주세요.';
    }

    if (!formData.department.trim()) {
      newErrors.department = '소속/직함은 필수입니다';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // ?먮윭 硫붿떆吏 ?쒓굅
    if (errors[name as keyof FormErrors]) {
      setErrors(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  // ?쒓렇 ?낅젰 ?곹깭
  const [tagInput, setTagInput] = useState<string>('');
  const [isComposing, setIsComposing] = useState<boolean>(false);

  // ?쒓렇 ?낅젰 ?몃뱾??
  const handleTagInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // ?쇳몴媛 ?낅젰?섎㈃ ?쒓굅?섍퀬 ?쒓렇 異붽?
    if (value.includes(',')) {
      const newTag = value.replace(',', '').trim();
      if (newTag && !formData.tags.includes(newTag)) {
        setFormData(prev => ({
          ...prev,
          tags: [...prev.tags, newTag]
        }));
      }
      setTagInput('');
    } else {
      setTagInput(value);
    }
  };

  // ?쒓? 議고빀 ?쒖옉
  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  // ?쒓? 議고빀 ??
  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  // ?쒓렇 ???ㅼ슫 ?몃뱾??(?뷀꽣)
  const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // ?쒓? 議고빀 以묒씪 ?뚮뒗 ?뷀꽣 泥섎━ ?덊븿
    if (isComposing) {
      return;
    }

    const value = tagInput.trim();
    
    // ?뷀꽣瑜??뚮?????
    if (e.key === 'Enter' && value) {
      e.preventDefault();
      
      // ?대? 議댁옱?섎뒗 ?쒓렇?몄? ?뺤씤
      if (!formData.tags.includes(value)) {
        setFormData(prev => ({
          ...prev,
          tags: [...prev.tags, value]
        }));
      }
      
      // ?낅젰 ?꾨뱶 珥덇린??
      setTagInput('');
    }
    
    // 諛깆뒪?섏씠?ㅻ줈 留덉?留??쒓렇 ??젣
    if (e.key === 'Backspace' && !value && formData.tags.length > 0) {
      const lastTag = formData.tags[formData.tags.length - 1];
      setFormData(prev => ({
        ...prev,
        tags: prev.tags.slice(0, -1)
      }));
      setTagInput(lastTag);
    }
  };

  // ?쒓렇 ??젣 ?몃뱾??
  const handleRemoveTag = (indexToRemove: number) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter((_, index) => index !== indexToRemove)
    }));
  };

  const handleImageUpload = async (file: File, type: 'thumbnail' | 'banner' | 'introduction') => {
    try {
      setMessage(null);
      
      // ?ㅼ젣 API瑜??듯븳 ?대?吏 ?낅줈??
      const imageUrl = await mentorApiService.uploadImage(file, type);
      
      // 誘몃━蹂닿린??濡쒖뺄 URL???앹꽦
      const previewUrl = URL.createObjectURL(file);
      
      if (type === 'thumbnail') {
        setThumbnailPreview(previewUrl);
        setFormData(prev => ({ ...prev, imageUrl: imageUrl }));
      } else if (type === 'banner') {
        setBannerPreview(previewUrl);
        setFormData(prev => ({ ...prev, bannerUrl: imageUrl }));
      } else if (type === 'introduction') {
        setIntroductionImagePreview(previewUrl);
        setFormData(prev => ({ ...prev, introduction: imageUrl }));
      }
      
      setMessage({ type: 'success', text: '이미지가 업로드되었습니다.' });
    } catch (error) {
      /// console.error('?대?吏 ?낅줈???ㅻ쪟:', error);
      setMessage({ type: 'error', text: '이미지 업로드에 실패했습니다.' });
    }
  };

  const handleImageClick = (type: 'thumbnail' | 'banner' | 'introduction') => {
    if (type === 'thumbnail') {
      thumbnailInputRef.current?.click();
    } else if (type === 'banner') {
      bannerInputRef.current?.click();
    } else if (type === 'introduction') {
      introductionImageInputRef.current?.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'thumbnail' | 'banner' | 'introduction') => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        handleImageUpload(file, type);
      } else {
        setMessage({ type: 'error', text: '이미지 파일만 업로드 가능합니다.' });
      }
    }
  };

  const handleSaveDraft = async () => {
    try {
      setMessage(null);
      // API ?붿껌???꾪빐 tags瑜??쇳몴濡?援щ텇??臾몄옄?대줈 蹂??
      const dataToSave: MentorData = { 
        ...formData, 
        tags: formData.tags.join(','), 
        fullSaved: false 
      };
      
      /// console.log('?뮶 ?꾩떆 ????붿껌 ?곗씠??', dataToSave);
      
      await mentorApiService.saveDraft(dataToSave);
      setMessage({ type: 'success', text: '임시 저장되었습니다.' });
    } catch (error) {
      /// console.error('?꾩떆 ????ㅻ쪟:', error);
      setMessage({ type: 'error', text: '임시 저장에 실패했습니다.' });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    try {
      // API ?붿껌???꾪빐 tags瑜??쇳몴濡?援щ텇??臾몄옄?대줈 蹂??
      const dataToSubmit: MentorData = { 
        ...formData, 
        tags: formData.tags.join(','), 
        fullSaved: true 
      };
      
      /// console.log(`?렞 硫섑넗 ${isEditMode ? '?섏젙' : '?깅줉'} ???쒖텧 ?곗씠??`, dataToSubmit);
      // console.log('?뼹截??낅줈?쒕맂 ?대?吏 誘몃━蹂닿린 ?곹깭:', {
      //   thumbnailPreview,
      //   bannerPreview,
      //   introductionImagePreview
      // });
      
      if (isEditMode && mentorId) {
        // ?섏젙 紐⑤뱶
        await mentorApiService.updateMentor(parseInt(mentorId), dataToSubmit);
        setMessage({ type: 'success', text: '멘토가 성공적으로 수정되었습니다' });
        // ?섏젙 紐⑤뱶?먯꽌???섏씠吏瑜??좎??섍굅??紐⑸줉?쇰줈 ?대룞
        setTimeout(() => {
          window.location.href = '/admin/coffee-chat/mentor';
        }, 2000);
      } else {
        // ?깅줉 紐⑤뱶
        await mentorApiService.createMentor(dataToSubmit);
        setMessage({ type: 'success', text: '멘토가 성공적으로 등록되었습니다' });
        
        // ?깅줉 紐⑤뱶?먯꽌留???珥덇린??
        setFormData({
          name: '',
          email: '',
          department: '',
          tags: [],
          categoryName: '',
          imageUrl: '',
          bannerUrl: '',
          introduction: ''
        });
        setThumbnailPreview('');
        setBannerPreview('');
        setIntroductionImagePreview('');
        setTagInput('');
      }
    } catch (error) {
      /// console.error('硫섑넗 ?깅줉 ?ㅻ쪟:', error);
      setMessage({ 
        type: 'error', 
        text: error instanceof Error ? error.message : '등록에 실패했습니다.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer>
      <TitleSection>
        <PageTitle>{isEditMode ? '멘토 수정' : '멘토 등록'}</PageTitle>
      </TitleSection>

      {message && <MessageBox $variant={message.type}>{message.text}</MessageBox>}

      <Form onSubmit={handleSubmit} $loading={isSubmitting}>
        <FormRow>
          <InputGroup>
            <Label $required>멘토 이름</Label>
            <InputWrapper>
              <InputBox>
                <TextInput
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="멘토 이름을 입력해주세요."
                />
              </InputBox>
            </InputWrapper>
            {errors.name && <ErrorText>{errors.name}</ErrorText>}
          </InputGroup>

          <InputGroup>
            <Label $required>소속/직함</Label>
            <InputWrapper>
              <InputBox>
                <TextInput
                  type="text"
                  name="department"
                  value={formData.department}
                  onChange={handleInputChange}
                  placeholder="소속/직함을 입력해주세요."
                />
              </InputBox>
            </InputWrapper>
            {errors.department && <ErrorText>{errors.department}</ErrorText>}
          </InputGroup>
        </FormRow>

        <FormRow>
          <InputGroup>
            <Label $required>멘토 이메일</Label>
            <InputWrapper>
              <InputBox>
                <TextInput
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="이메일을 입력해주세요."
                />
              </InputBox>
            </InputWrapper>
            {errors.email && <ErrorText>{errors.email}</ErrorText>}
          </InputGroup>
        </FormRow>

        <FullWidthSection>
          <Label>태그</Label>
          <InputWrapper>
            <InputBox>
              <TagsContainer>
                {formData.tags.map((tag, index) => (
                  <Tag key={index}>
                    <TagText>{tag}</TagText>
                    <TagRemoveButton
                      type="button"
                      onClick={() => handleRemoveTag(index)}
                      aria-label={`${tag} 태그 제거`}
                    >
                      ×
                    </TagRemoveButton>
                  </Tag>
                ))}
                <TagInput
                  type="text"
                  value={tagInput}
                  onChange={handleTagInputChange}
                  onKeyDown={handleTagKeyDown}
                  onCompositionStart={handleCompositionStart}
                  onCompositionEnd={handleCompositionEnd}
                  placeholder={formData.tags.length === 0 ? '태그를 입력하고 엔터 또는 쉼표를 눌러주세요' : ''}
                />
              </TagsContainer>
            </InputBox>
          </InputWrapper>
          <HelperText>엔터 또는 쉼표(,)로 태그를 구분합니다. 백스페이스로 마지막 태그를 다시 편집할 수 있습니다.</HelperText>
        </FullWidthSection>

        <FullWidthSection>
          <Label>카테고리</Label>
          <InputWrapper>
            <SelectBox>
              <SelectInput
                name="categoryName"
                value={formData.categoryName}
                onChange={handleInputChange}
              >
                <option value="">카테고리를 선택해주세요.</option>
                <option value="의학">의학</option>
                <option value="연구">연구</option>
                <option value="임상">임상</option>
                <option value="경영">경영</option>
                <option value="기타">기타</option>
              </SelectInput>
              <SelectIcon>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </SelectIcon>
            </SelectBox>
          </InputWrapper>
        </FullWidthSection>

        <ImageUploadSection>
          <ThumbnailGroup>
            <Label>썸네일</Label>
            <ImagePreview>
              <ThumbnailUpload onClick={() => handleImageClick('thumbnail')}>
                {thumbnailPreview ? (
                  <PreviewImage src={thumbnailPreview} alt="썸네일 미리보기" />
                ) : (
                  <UploadPlaceholder>
                    <UploadIcon>
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.9994 4.13721C16.6622 4.13721 17.1994 4.67447 17.1994 5.33721V14.8039H26.6661C27.3288 14.8039 27.8661 15.3411 27.8661 16.0039C27.8661 16.6666 27.3288 17.2039 26.6661 17.2039H17.1994V26.6705C17.1994 27.3333 16.6622 27.8705 15.9994 27.8705C15.3367 27.8705 14.7994 27.3333 14.7994 26.6705V17.2039H5.33281C4.67007 17.2039 4.13281 16.6666 4.13281 16.0039C4.13281 15.3411 4.67007 14.8039 5.33281 14.8039H14.7994V5.33721C14.7994 4.67447 15.3367 4.13721 15.9994 4.13721Z" fill="#448181"/>
                      </svg>
                    </UploadIcon>
                    <UploadText>썸네일 이미지 업로드</UploadText>
                  </UploadPlaceholder>
                )}
              </ThumbnailUpload>
              <HiddenInput
                ref={thumbnailInputRef}
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, 'thumbnail')}
              />
            </ImagePreview>
          </ThumbnailGroup>

          <ThumbnailGroup>
            <Label>배너</Label>
            <ImagePreview>
              <BannerUpload onClick={() => handleImageClick('banner')}>
                {bannerPreview ? (
                  <PreviewImage src={bannerPreview} alt="배너 미리보기" />
                ) : (
                  <UploadPlaceholder>
                    <UploadIcon>
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.9994 4.13721C16.6622 4.13721 17.1994 4.67447 17.1994 5.33721V14.8039H26.6661C27.3288 14.8039 27.8661 15.3411 27.8661 16.0039C27.8661 16.6666 27.3288 17.2039 26.6661 17.2039H17.1994V26.6705C17.1994 27.3333 16.6622 27.8705 15.9994 27.8705C15.3367 27.8705 14.7994 27.3333 14.7994 26.6705V17.2039H5.33281C4.67007 17.2039 4.13281 16.6666 4.13281 16.0039C4.13281 15.3411 4.67007 14.8039 5.33281 14.8039H14.7994V5.33721C14.7994 4.67447 15.3367 4.13721 15.9994 4.13721Z" fill="#448181"/>
                      </svg>
                    </UploadIcon>
                    <UploadText>배너 이미지 업로드</UploadText>
                  </UploadPlaceholder>
                )}
              </BannerUpload>
              <HiddenInput
                ref={bannerInputRef}
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, 'banner')}
              />
            </ImagePreview>
          </ThumbnailGroup>
        </ImageUploadSection>

        <FullWidthSection>
          <Label>멘토 소개 이미지</Label>
          <ImagePreview>
            <IntroductionUpload onClick={() => handleImageClick('introduction')}>
              {introductionImagePreview ? (
                <PreviewImage src={introductionImagePreview} alt="멘토 소개 이미지 미리보기" />
              ) : (
                <UploadPlaceholder>
                  <UploadIcon>
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.9994 4.13721C16.6622 4.13721 17.1994 4.67447 17.1994 5.33721V14.8039H26.6661C27.3288 14.8039 27.8661 15.3411 27.8661 16.0039C27.8661 16.6666 27.3288 17.2039 26.6661 17.2039H17.1994V26.6705C17.1994 27.3333 16.6622 27.8705 15.9994 27.8705C15.3367 27.8705 14.7994 27.3333 14.7994 26.6705V17.2039H5.33281C4.67007 17.2039 4.13281 16.6666 4.13281 16.0039C4.13281 15.3411 4.67007 14.8039 5.33281 14.8039H14.7994V5.33721C14.7994 4.67447 15.3367 4.13721 15.9994 4.13721Z" fill="#448181"/>
                    </svg>
                  </UploadIcon>
                  <UploadText>멘토 소개 이미지 업로드</UploadText>
                </UploadPlaceholder>
              )}
            </IntroductionUpload>
            <HiddenInput
              ref={introductionImageInputRef}
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'introduction')}
            />
          </ImagePreview>
        </FullWidthSection>

        <Actions>
          <ActionButtons>
            <SaveDraftButton type="button" onClick={handleSaveDraft}>
              <ButtonContent>
                <ButtonLabel>임시 저장</ButtonLabel>
              </ButtonContent>
            </SaveDraftButton>

            <SubmitButtonWrap>
              <SubmitButton type="submit" disabled={isSubmitting}>
                <ButtonContent>
                  <ButtonLabel>
                    {isSubmitting ? (isEditMode ? '수정 중..' : '등록 중..') : (isEditMode ? '수정하기' : '등록하기')}
                  </ButtonLabel>
                </ButtonContent>
              </SubmitButton>
            </SubmitButtonWrap>
          </ActionButtons>
        </Actions>
      </Form>
    </PageContainer>
  );
};

export default MentorRegisterComponent;
